import React, { useState } from "react";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import CardHeader from "./../../Components/CardHeader";
import { faArrowLeft, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { toastSuccess, toastError } from "../../Components/ToastNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { getjwt } from "../../services/authServices";
import { addTicketTypes } from "../../services/ticketType";

const headerButtons = [
  { buttonTitle: "Back", buttonUrl: "../tickettypes", icon: faArrowLeft },
];
const INITIAL_DATA = {
  ticket_type: "",
  status: 1,
};

const Validater = (value) => {
  const errors = {};
  if (!value["ticket_type"]) {
    errors.ticket_type = "tickettype is required";
  }
  return errors;
};

const TicketTypeAdd = () => {
  const navgate = useNavigate();
  const [data, setData] = useState(INITIAL_DATA);
  const [formErrors, setformErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    let inputs = {
      ...data,
      [name]: value,
    };
    setformErrors(Validater(inputs));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = getjwt();
    if (data.ticket_type !== "") {
      data["token_data"] = JSON.parse(token);
      addTicketTypes(data)
        .then((res) => {
          if (res.status === 201) {
            toastSuccess("Successfully created TicketType");
            navgate("../tickettypes");
          }
        })
        .catch((err) => {
          err.response.data.errors.map((errors) =>
            toastError(`Failed: ${errors.error}`)
          );
        });
    } else {
      setformErrors(Validater(data));
    }
  };

  return (
    <div className="container-fluid">
      <CardHeader headerItems={headerButtons} title="ADD TICKETTYPE" />
      <Card className="mb-3 border-0 shadow-sm rounded-2">
        <Card.Body>
          <div className="form-wrapper">
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className="fw-600">TicketType</Form.Label>
                  <Form.Control
                    type="text"
                    name="ticket_type"
                    placeholder="TicketType"
                    onChange={handleChange}
                    value={data.ticket_type}
                    className="border-2"
                    isInvalid={formErrors.ticket_type}
                  />
                  {formErrors.ticket_type && (
                    <Form.Control.Feedback type="invalid">
                      {formErrors.ticket_type}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Row>

              <Button
                variant="primary"
                type="submit"
                className="shadow rounded-5 mt-4"
              >
                <FontAwesomeIcon icon={faCircleCheck} /> Create TicketType
              </Button>
            </Form>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TicketTypeAdd;
